/**
 * Course detail is mounted at either:
 * - /user/courses/:courseId — opened from Purchased courses (sidebar highlights Purchased)
 * - /user/browse/course/:courseId — opened from All Course (sidebar highlights All Course)
 */
export function getUserCourseSectionPaths(pathname, courseId) {
  const id = courseId != null ? String(courseId) : '';
  const fromBrowse = Boolean(id && pathname.startsWith('/user/browse/course/'));
  const isPublic = Boolean(id && pathname.startsWith('/courses/'));
  
  const courseBase = fromBrowse
    ? `/user/browse/course/${id}`
    : isPublic
    ? `/courses/${id}`
    : `/user/courses/${id}`;

  const listBase = fromBrowse ? '/user/browse' : isPublic ? '/courses' : '/user/courses';
  const listLabel = fromBrowse ? 'All courses' : isPublic ? 'All courses' : 'Purchased courses';
  const quizPath = `${courseBase}/quiz`;
  
  return { fromBrowse, isPublic, courseBase, listBase, listLabel, quizPath };
}
